export default "__VITE_ASSET__BvzKFG2j__"